'use client';

import { channelDetailsByIdV2QueryOption } from '@/entities';
import { useSalePageQuery } from '@/entities/salePage';
import { AnalyticsTrackEnter } from '@/lib/AnalyticsTrackEnter';
import { pushDataLayer } from '@/lib/gtmDataLayer';
import { useQuery } from '@/lib/useWrappingQuery';
import { isNonNil } from '@vuddy/utils';
import { useEffect } from 'react';

interface SaleTrackEnterEventProps {
  salePageId: number;
}

export const SaleTrackEnterEvent = ({
  salePageId,
}: SaleTrackEnterEventProps) => {
  const salePageQuery = useSalePageQuery(salePageId);
  const channelId = salePageQuery.data?.channelId;

  const { data: channelData } = useQuery({
    ...channelDetailsByIdV2QueryOption({ pathVariables: channelId }),
    enabled: isNonNil(channelId),
  });

  const isSecondaryCreator = channelData?.type === 'SECONDARY_CREATOR';

  const salePage = salePageQuery.data;

  useEffect(() => {
    if (!salePage) return;
    pushDataLayer({
      event: 'view_item',
      item_id: String(salePage.id),
      item_name: salePage.name,
      item_type: salePage.type === 'CLASS' ? 'class' : 'goods',
      item_category: salePage.type,
      creator_name: salePage.channel.name,
    });
  }, [salePage]);

  return isNonNil(salePage) ? (
    <AnalyticsTrackEnter
      category="shop"
      eventName="enter_sale"
      properties={{
        channel_id: salePage.channelId,
        sale_type: salePage.type,
        sale_page_id: salePageId,
        channel_type: isSecondaryCreator ? 'secondary_creator' : 'creator',
      }}
    />
  ) : null;
};
